module.exports = {"attributes":{"width":"26","height":"26","viewBox":"0 0 26 26","xmlns":"http://www.w3.org/2000/svg"},"content":"<g fill-rule=\"nonzero\">     <path d=\"M19 6v12h1V6h-1zm0-2h1a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2zM12 11v7h1v-7h-1zm0-2h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-7c0-1.1.9-2 2-2zM5 16v2h1v-2H5zm0-2h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2z\"/>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/traffic.svg
// module id = 1453
// module chunks = 0